import React, { Component } from 'react';
import { Nav, NavItem } from 'reactstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  AppAsideToggler,
  AppNavbarBrand,
  AppSidebarToggler
} from '@coreui/react';
import logo from '../../assets/img/brand/logo.svg';
import { ContextConsumer } from '../../Context';

const propTypes = {
  children: PropTypes.node
};

const defaultProps = {};

class DefaultHeader extends Component {
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 30, height: 25, alt: 'CoreUI Logo' }}
          minimized={{ src: logo, width: 30, height: 25, alt: 'CoreUI Logo' }}
        />
        <span className="logo-text">Moby.DRIVE</span>
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="ml-auto" navbar>
          <ContextConsumer>
            {({ logout }) => (
              <NavItem className="px-3">
                <Link to="/login" replace className="nav-link" onClick={logout}>
                  <i className="icon-map mr-2" />
                  Logout
                </Link>
              </NavItem>
            )}
          </ContextConsumer>
        </Nav>
        {/* <AppAsideToggler className="d-md-down-none" /> */}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
